/**
 * Created by minimus on 12.11.2015.
 */
(function ($) {
  const localeStrings = samProOptions.localeStrings;
  const intervalType = 'months';
  const labelFormat = 'MMM dd';
  const startDate = samProOptions.periods[samProOptions.period].start;
  const endDate = samProOptions.periods[samProOptions.period].end;
  const aData = samProOptions.adata;
  const ajaxUrl = samProOptions.ajaxUrl;
  const nonce = samProOptions.samProNonce;
  const period = samProOptions.period;
  const periods = samProOptions.periods;
  const chartURI = `${ajaxUrl}?action=sam_load_chart_data&sam_pro_nonce=${nonce}`;
  const gridURI = `${ajaxUrl}?action=sam_load_grid_data&sam_pro_nonce=${nonce}`;
  const childGridURI = `${ajaxUrl}?action=sam_load_grid_child_data&start=${startDate}&end=${endDate}&adata=${encodeURIComponent(aData)}&period=${period}&sam_pro_nonce=${nonce}`;
  const pieURI = `${ajaxUrl}?action=sam_load_pie_data&sam_pro_nonce=${nonce}`;
  const pie2URI = `${ajaxUrl}?action=sam_load_pie_data_2&sam_pro_nonce=${nonce}`;
  const pieParams = `&start=${startDate}&end=${endDate}&period=${period}&adata=${encodeURIComponent(aData)}`;

  $(document).ready(function () {
    function getAdChart(aid, pid) {
      const adChartURI = `${ajaxUrl}?action=sam_load_ad_chart_data&sam_pro_nonce=${nonce}`;
      const adChartParams = `&aid=${aid}&pid=${pid}&start=${startDate}&end=${endDate}&period=${period}&adata=${encodeURIComponent(aData)}`;
      const dmAdChart = ej.DataManager({
        url: adChartURI + adChartParams,
        requestType: 'json',
        adaptor: new ej.UrlAdaptor()
      });
      const queryAdChart = new ej.Query();
      const promise = dmAdChart.executeQuery(queryAdChart);
      promise.done((e) => {
        const chart = $('#ad-chart').ejChart({
          enableCanvasRendering: true,
          canResize: true,
          isResponsive: true,
          theme: ej.datavisualization.Chart.Theme.FlatLight,
          title: {
            text: periods[period].title,
            font: {
              fontFamily: '"Open Sans",sans-serif',
              fontWeight: 'bold'
            }
          },
          primaryXAxis: {
            valueType: "datetime",
            intervalType: intervalType,
            labelFormat: labelFormat
          },
          commonSeriesOptions: {
            tooltip: {
              visible: true,
              format: "#series.name#: #point.y#"
            }
          },
          series: [
            {
              name: localeStrings.impressions,
              type: 'column',
              dataSource: dmAdChart,
              xName: 'mdate',
              yName: 'hits',
              query: e.query,//queryAdChart,
              marker: {
                dataLabel: {
                  visible: true,
                  textPosition: "top",
                  fill: "#FF7777",
                  verticalTextAlignment: "top",
                  offset: 20,
                  shape: "rectangle",
                  font: {color: "white"}
                }
              }
            },
            {
              name: localeStrings.clicks,
              type: 'column',
              dataSource: dmAdChart,
              xName: 'mdate',
              yName: 'clicks',
              query: e.query,//queryAdChart,
              marker: {
                dataLabel: {
                  visible: true,
                  textPosition: "top",
                  fill: "#ffd45a",
                  verticalTextAlignment: "top",
                  offset: 20,
                  shape: "rectangle",
                  font: {color: "white"}
                }
              }
            }
          ]
        }).data("ejChart");
        chart.redraw();
      });

      return false;
    }

    const adChartDialog = $('#chart-dialog').ejDialog({
      width: 950,
      allowDraggable: true,
      enableModal: true,
      showOnInit: false
    }).data('ejDialog');

    $('#close-chart').on('click', (e) => {
      e.preventDefault();
      adChartDialog.close();
    });

    const dmChart = ej.DataManager({
      url: chartURI,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const queryChart = new ej.Query()
      .addParams('start', startDate)
      .addParams('end', endDate)
      .addParams('adata', aData)
      .addParams('period', period);
    const chart = $('#chart').ejChart({
      //locale: ejLocale,
      enableCanvasRendering: true,
      canResize: true,
      isResponsive: true,
      //enable3D: true,
      theme: ej.datavisualization.Chart.Theme.FlatLight,
      title: {
        text: periods[period].title,
        font: {
          fontFamily: '"Open Sans",sans-serif',
          fontWeight: 'bold'
        }
      },
      primaryXAxis: {
        valueType: "datetime",
        intervalType: intervalType,
        labelFormat: labelFormat
      },
      commonSeriesOptions: {
        tooltip: {
          visible: true,
          format: "#series.name#: #point.y#"
        }
      },
      series: [
        {
          name: localeStrings.impressions,
          type: 'column',
          dataSource: dmChart,
          xName: 'mdate',
          yName: 'hits',
          query: queryChart,
          marker: {
            dataLabel: {
              visible: true,
              textPosition: "top",
              fill: "#FF7777",
              verticalTextAlignment: "top",
              offset: 20,
              shape: "rectangle",
              font: {color: "white"}
            }
          }
        },
        {
          name: localeStrings.clicks,
          type: 'column',
          dataSource: dmChart,
          xName: 'mdate',
          yName: 'clicks',
          query: queryChart,
          marker: {
            dataLabel: {
              visible: true,
              textPosition: "top",
              fill: "#ffd45a",
              verticalTextAlignment: "top",
              offset: 20,
              shape: "rectangle",
              font: {color: "white"}
            }
          }
        }
      ]
    });

    const dmGrid = ej.DataManager({
      url: gridURI,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmChildGrid = ej.DataManager({
      url: childGridURI,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const gridColumns = [
      {field: 'pid', headerText: localeStrings.adId, isPrimaryKey: true, textAlign: ej.TextAlign.Right, width: 70},
      {field: 'title', headerText: localeStrings.aname},
      {field: 'hits', headerText: localeStrings.impressions, textAlign: ej.TextAlign.Right, width: 100},
      {field: 'clicks', headerText: localeStrings.clicks, textAlign: ej.TextAlign.Right, width: 80},
      {field: 'income', headerText: localeStrings.paidUp, textAlign: ej.TextAlign.Right, width: 100},
      {field: 'cpm', headerText: 'CPM', textAlign: ej.TextAlign.Right, width: 100},
      {field: 'cpc', headerText: 'CPC', textAlign: ej.TextAlign.Right, width: 100},
      {field: 'ctr', headerText: 'CTR', textAlign: ej.TextAlign.Right, width: 100}
    ];
    const childGridColumns = [
      {field: 'pid', headerText: 'Place ID', isPrimaryKey: true, visible: false},
      {field: 'aid', headerText: localeStrings.adId, textAlign: ej.TextAlign.Right, width: 70},
      {field: 'title', headerText: localeStrings.aname},
      {field: 'hits', headerText: localeStrings.impressions, textAlign: ej.TextAlign.Right, width: 100},
      {field: 'clicks', headerText: localeStrings.clicks, textAlign: ej.TextAlign.Right, width: 80},
      {field: 'income', headerText: localeStrings.paidUp, textAlign: ej.TextAlign.Right, width: 100},
      {field: 'cpm', headerText: 'CPM', textAlign: ej.TextAlign.Right, width: 100},
      {field: 'cpc', headerText: 'CPC', textAlign: ej.TextAlign.Right, width: 100},
      {field: 'ctr', headerText: 'CTR', textAlign: ej.TextAlign.Right, width: 100}
    ];
    const grid = $('#grid').ejGrid({
      dataSource: dmGrid,
      query: new ej.Query()
        .addParams('start', startDate)
        .addParams('end', endDate)
        .addParams('adata', aData)
        .addParams('period', period),
      allowTextWrap: true,
      allowPaging: true,
      pageSettings: {pageSize: samProOptions.itemsPerPage},
      allowSelection: true,
      selectionType: ej.Grid.SelectionType.Single,
      selectionSettings: {
        selectionMode: [ej.Grid.SelectionMode.Row],
        enableToggle: true
      },
      columns: gridColumns,
      childGrid: {
        dataSource: dmChildGrid,
        queryString: "pid",
        allowTextWrap: true,
        allowSelection: true,
        selectionType: ej.Grid.SelectionType.Single,
        selectionSettings: {
          selectionMode: [ej.Grid.SelectionMode.Row],
          enableToggle: true
        },
        toolbarSettings: {
          showToolbar: true,
          customToolbarItems: ['Ad_Chart']
        },
        columns: childGridColumns,
        actionComplete: function (args) {
          if (args.requestType === 'refresh') {
            const $toolbar = $(`#${this._id}_toolbarItems`);
            const li = $(`#${this._id}_Ad_Chart`);
            $toolbar.ejToolbar('disableItem', li);
          }
        },
        toolbarClick: function (args) {
          const tbarObj = $(args.target);
          const rec = this.getSelectedRecords();
          const pid = rec[0].pid;
          const aid = rec[0].aid;
          if (tbarObj.hasClass('Ad_Chart')) {
            const adChart = getAdChart(aid, pid);
            adChartDialog.open();
            //adChart.redraw();
          }
        },
        recordClick: function (args) {
          const $toolbar = $('#' + this._id + '_toolbarItems');
          const li = $('#' + this._id + '_Ad_Chart');
          const recs = this.getSelectedRecords();
          const action = (recs.length === 0) ? 'disableItem' : 'enableItem';
          $toolbar.ejToolbar(action, li);
        },
        create: function (args) {
          $('.Ad_Chart').parent('li').attr('title', 'Statistics');
        }
      }
    }).data('ejGrid');

    const dmPie = ej.DataManager({
      url: pieURI + pieParams,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmPie2 = ej.DataManager({
      url: pie2URI + pieParams,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const pieHits = $('#pieChartHits').ejChart({
      //size: {width: '250px', height: '300px'},
      title: {
        text: localeStrings.impressions,
        font: {
          fontFamily: '"Open Sans",sans-serif',
          fontWeight: 'bold',
          size: '20px'
        }
      },
      series: [{
        dataSource: dmPie,
        query: new ej.Query(),
        xName: 'title',
        yName: 'hits',
        type: 'doughnut',
        tooltip: {
          format: "#point.x# : #point.y#",
          visible: true
        },
        labelPosition: 'outside',
        doughnutCoefficient: 0.4,
        marker: {
          dataLabel: {
            visible: true,
            connectorLine: {height: 20},
            font: {size: '13px'}
          }
        }
      }],
      isResponsive: true,
      legend: {visible: true}
    });
    const pieClicks = $('#pieChartClicks').ejChart({
      title: {
        text: localeStrings.clicks,
        font: {
          fontFamily: '"Open Sans",sans-serif',
          fontWeight: 'bold',
          size: '20px'
        }
      },
      series: [{
        dataSource: dmPie2,
        query: new ej.Query(),
        tooltip: {
          format: "#point.x# : #point.y#",
          visible: true
        },
        xName: 'title',
        yName: 'clicks',
        type: 'doughnut',
        marker: {
          dataLabel: {
            visible: true,
            connectorLine: {height: 20},
            font: {size: '13px'}
          }
        },
        labelPosition: 'outside'
      }],
      isResponsive: true,
      legend: {visible: true}
    });
  });
})(jQuery);